import React, { createContext, FC, useReducer } from 'react';
import { DmsActionDispatcher, dmsReducer, DmsState, initialState } from './dms.state';

export const DmsStateContext = createContext<DmsState | undefined>(undefined);
export const DmsDispatchContext = createContext<DmsActionDispatcher | undefined>(undefined);

export const DmsProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(dmsReducer, initialState);

    return (
        <DmsStateContext.Provider value={state}>
            <DmsDispatchContext.Provider value={dispatch}>{children}</DmsDispatchContext.Provider>
        </DmsStateContext.Provider>
    );
};
